var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.479,
    height: 14.471,
    viewBox: "0 0 12.479 14.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-393.638 -2126.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Op_component_1",
    "data-name": "Op component 1",
    d: "M403.779,2130.337l.931-.937.958.959-.932.922a6.131,6.131,0,0,1,1.26,5.088,6.009,6.009,0,0,1-2.454,3.828,6.258,6.258,0,0,1-8.288-.852,6.167,6.167,0,0,1-.049-8.27A6.276,6.276,0,0,1,403.779,2130.337Zm-3.9,9.645a4.81,4.81,0,1,0-4.83-4.866A4.822,4.822,0,0,0,399.881,2139.982Z",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Op_component_2",
    "data-name": "Op component 2",
    d: "M399.876,2128.3c-.449,0-.9,0-1.345,0a.69.69,0,1,1,0-1.38q1.361-.006,2.723,0a.691.691,0,0,1,.711.683.68.68,0,0,1-.708.7c-.459,0-.918,0-1.378,0Z",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Op_component_3",
    "data-name": "Op component 3",
    d: "M396.687,2135.484l.785-.775,1.375,1.384,3.344-3.326.776.777-4.1,4.073Z",
    fill: "#6f6f6f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTime);
export default __webpack_public_path__ + "static/media/DateTime.3eb0409a5db65eb773250ae1ea2b1b56.svg";
export { ForwardRef as ReactComponent };